import src from "IMAGE";
export default { src, width: 211, height: 423, blurWidth: 4, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAQ0lEQVR42o2KOQrAMAwEV3YngVCh6/8vDXIgkM4DU+wyqCrq7mNEAJlJo7uDmYEp5hARENFbqCrWWjiYGfbe+PiNKx5kUQNahD3Z5QAAAABJRU5ErkJggg=="};
